import React, {useState, useEffect} from 'react'
import {useNavigate} from 'react-router-dom'
import {ParagraphText} from '@thryvlabs/maverick'
import {toast} from 'react-toastify'
import io from 'socket.io-client'
import {OverlayLoader} from '../components/ui/payment-information'
import calculatingTaxesGif from '../assets/calculating-tax-image.png'
import thryvPeek from '../assets/proposal-tool/thryv-peek-2.png'
// import {useViewport} from '../utils/useViewport'

import {DesktopLayout} from '../components/payment-information-components/desktop-layout'
import MobileLayout, {
  MobilePaymentHeader,
} from '../components/payment-information-components/mobile-layout'
import NotFoundPage from '../components/not-found-page'
import ErrorPage from '../components/error-page'
import {useUserFeatures} from '../context/user-features-context'
import {useBillingInfo} from '../components/payment-information-components/contexts/billing-info-context'
import {usePaymentOrder} from '../components/payment-information-components/hooks/use-payment-order'
import {
  AUS_PAYMENT_METHODS,
  CA_PAYMENT_METHODS,
  NZ_PAYMENT_METHODS,
  PAYMENT_METHODS,
  REACT_APP_OOE_SERVICE_URL,
  ONE_TIME_FEES,
  INITIAL_PAYMENT_STATE,
} from '../components/payment-information-components/constants'
import {
  getPlanIcon,
  createTransitionCoupon,
  getLoadingMessage,
} from '../components/payment-information-components/utils'
import {useRecurlyPayment} from '../components/payment-information-components/contexts/recurly-payment-context'
import {usePaymentCheckboxes} from '../components/payment-information-components/contexts/payment-checkboxes-context'
import {getAmountToQuantityMap} from '../utils/lift-lead-options'
import {SOCIAL_ADS_BNI_PLAN_CODES} from '../utils/constants'
import {KEEP_THRYV_PREFIX_PRODUCT_CODES} from '../components/payment-information-components/constants'
import {useDispatch, useSelector} from 'react-redux'
import {setMobileViewStatus} from '../app-store/kpGlobalStateSlice'
import {useAsync} from '../utils/use-async'
import {usePaymentAuthClient} from '../components/payment-information-components/contexts/payment-auth-context'
import {selectProposalInfo} from '../app-store/ProposalSlice'

const NON_ADDED_PLANS = [
  'addon-5-signatures_usage',
  'app-websitebuilder',
  'cc_basicpls-5-thryv-m2m',
  'thryvprfee',
]

const shouldFetchPurchasePlanFallback = (orderDetails, randomId) =>
  Boolean(randomId) && (!orderDetails?.linkId || !orderDetails?.thryvId)

// Network-level fetch failures (Safari "Load failed", Chrome "Failed to fetch")
// carry no .status, so they used to fall through to `throw error` and surface as
// an unhandled rejection (Fixes OOE-UI-1F)
const NETWORK_ERROR = {
  message: 'Network error. Please check your connection and try again.',
  status: null,
}

function PaymentInformation() {
  const client = usePaymentAuthClient()
  const {run} = useAsync({
    status: 'pending',
  })
  const navigate = useNavigate()

  const {setRecurlyAccountId, isFetching, isCVCVerified, isVerifying} =
    useBillingInfo()
  const {
    recurlyToken,
    isFetching: isFetchingRecurly,
    clearRecurlyToken,
    setType,
  } = useRecurlyPayment()
  const [processing, setProcessing] = React.useState(false)
  const [processingMessage, setProcessingMessage] = React.useState('')
  const [ccorderId, setCCOrderId] = React.useState(null)
  const [subscriptionIdAcc4, setSubscriptionIdAcc4] = React.useState(null)
  const [isProcessPurchaseComplete, setIsProcessPurchaseComplete] =
    React.useState(null)
  const [orderIdHeader, setOrderIdHeader] = React.useState(null)
  const [thryvId, setThryvId] = React.useState(null)
  const [clientEmail, setClientEmail] = React.useState(null)
  const [isNewOrder, setIsNewOrder] = React.useState(null)
  const [onboardingCalls, setOnboardingCalls] = React.useState(null)
  const [creativeCalls, setCreativeCalls] = React.useState(null)
  const [thryvSuccessServicesCalls, setThryvSuccessServicesCalls] =
    React.useState(null)
  const [isSEOIncluded, setIsSEOIncluded] = React.useState(null)
  const [softwareUpgraded, setSoftwareUpgraded] = React.useState(null)
  const [orderData5CU, setOrderData5CU] = React.useState(null)
  const [orderData4CU, setOrderData4CU] = React.useState(null)
  const [keapAccount, setKeapAccount] = React.useState(null)
  const [orderCoreDetails, setOrderCoreDetails] = React.useState(null)
  const {checkBoxesValues, setCheckBoxesValues} = usePaymentCheckboxes()
  const {agreedTerms} = checkBoxesValues
  const [paymentState, setPaymentState] = React.useState(INITIAL_PAYMENT_STATE)
  const [isLoading, setIsLoading] = React.useState(true)
  const [calculatingTaxes, setCalculatingTaxes] = React.useState(false)
  const [uuid, setUuid] = React.useState(null)
  const [finalStep, setFinalStep] = React.useState(false)
  const [connected, setConnected] = React.useState(false)
  const [currentStep, setCurrentStep] = React.useState(1)
  const [linkExpiryInMilliSec, setLinkExpiryInMilliSec] = useState(0)

  const [httpError, setHttpError] = React.useState(null)
  const [paymentRequestState, setPaymentRequestState] = React.useState({
    hasErrors: false,
    requested: false,
    merchantMessage: null,
  })
  const [isAddressUpdated, setIsAddressUpdated] = React.useState(false)
  const [isMobileViewEnabled, setMobileViewEnabledStatus] = useState(false)
  const proposalInfo = useSelector(selectProposalInfo)
  const dispatch = useDispatch()
  // const {isMobile} = useViewport()
  const nextStepCalled = React.useRef({
    step1: false,
    step2: false,
    step3: false,
  })
  const {Frontend_Preview_Payment: frontendPreviewPayment} = useUserFeatures()
  useEffect(() => {
    const checkDevice = () => {
      const userAgent = navigator.userAgent
      const mobileRegex =
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i
      const isMobileDevice =
        mobileRegex.test(userAgent) || window.innerWidth <= 768
      setMobileViewEnabledStatus(isMobileDevice)
      dispatch(setMobileViewStatus(isMobileDevice))
    }
    console.log(subscriptionIdAcc4)
    checkDevice()
    // window.addEventListener('resize', checkDevice)

    // return () => {
    //   window.removeEventListener('resize', checkDevice)
    // }
  }, [])

  const {is5Order, randomId} = usePaymentOrder()
  const isAusNZ = ['AU', 'NZ'].includes(paymentState.paymentInfo?.country)
  const isAus = paymentState.paymentInfo?.country === 'AU'
  const isNZ = paymentState.paymentInfo?.country === 'NZ'
  const isCA = paymentState.paymentInfo?.country === 'CA'

  const handleChangePaymentMethod = async paymentMethod => {
    setType(paymentMethod.value)
    console.log('Changing the payment method to :: ', paymentMethod)
    try {
      if (paymentMethod.value === 'invoice') {
        setPaymentState(prevState => ({
          ...prevState,
          paymentMethod,
        }))
        if (isAusNZ && randomId) {
          const url = is5Order
            ? 'cc/order/update-invoice-billed'
            : 'orders/update-invoice-billed'
          await client(url, {
            method: 'PATCH',
            data: {orderUuid: randomId, isInvoiceBilled: true},
          })
        }
        return
      }
      if (isAusNZ && randomId) {
        const url = is5Order
          ? 'cc/order/update-invoice-billed'
          : 'orders/update-invoice-billed'
        await client(url, {
          method: 'PATCH',
          data: {orderUuid: randomId, isInvoiceBilled: false},
        })
      }
      // Check if ACH coupon is already added to the account.
      // For multi-location, each location has its own Recurly account — check
      // all of them using the per-location Recurly account IDs returned by the
      // purchase-plan API. Fall back to the parent recurlyAccountId for
      // single-location orders or locations with no Recurly account yet.
      const locationPreviews = paymentState.paymentInfo?.locationPreviews
      const thryvIds = locationPreviews
        ? Object.keys(locationPreviews)
        : [paymentState.paymentInfo?.thryvId].filter(Boolean)
      const locationRecurlyAccountIds =
        paymentState.paymentInfo?.locationRecurlyAccountIds ?? {}
      const accountIdsToCheck =
        Object.keys(locationRecurlyAccountIds).length > 0
          ? Object.values(locationRecurlyAccountIds)
          : [paymentState.paymentInfo.recurlyAccountId]
      const accountIdParams = accountIdsToCheck
        .map(id => `accountIds=${encodeURIComponent(id)}`)
        .join('&')
      const url = `cc/order/fetchAccountCoupons?${accountIdParams}`
      const couponResults = await client(url)
      console.log('couponResults :: ', couponResults)
      const isMultiLocation = Object.keys(locationRecurlyAccountIds).length > 0
      const hasACHCoupon = coupons =>
        (coupons ?? []).some(
          ele =>
            ele.coupon?.code === 'ach-discount' &&
            ele.coupon?.state === 'redeemable',
        )
      if (isMultiLocation) {
        // Per-location: only insert/delete for locations that actually need it.
        // couponResults is { [recurlyAccountId]: coupons[] }; use
        // locationRecurlyAccountIds to map thryvId → recurlyAccountId.
        const insertThryvIds = []
        const deleteThryvIds = []
        for (const [thryvId, recurlyAcctId] of Object.entries(
          locationRecurlyAccountIds,
        )) {
          if (hasACHCoupon(couponResults[recurlyAcctId])) {
            deleteThryvIds.push(thryvId)
          } else {
            insertThryvIds.push(thryvId)
          }
        }
        const insertUrl = is5Order
          ? `cc/order/insertACHCoupon/${randomId}`
          : `orders/insertACHCoupon/${randomId}`
        const deleteUrl = is5Order
          ? `cc/order/deleteACHCoupon/${randomId}`
          : `orders/deleteACHCoupon/${randomId}`
        if (paymentMethod.value === 'ach' && insertThryvIds.length > 0) {
          await client(insertUrl, {
            data: {locationThryvIds: insertThryvIds},
            method: 'POST',
          })
        } else if (paymentMethod.value !== 'ach' && deleteThryvIds.length > 0) {
          await client(deleteUrl, {
            data: {locationThryvIds: deleteThryvIds},
            method: 'DELETE',
          })
        }
      } else {
        // Single-location: existing behavior — unchanged.
        const couponResultsArray = Array.isArray(couponResults)
          ? couponResults
          : Object.values(couponResults ?? {}).flat()
        const isACHCouponAlreadyAddedInRecurly = couponResultsArray.find(
          ele =>
            ele.coupon.code === 'ach-discount' &&
            ele.coupon.state === 'redeemable',
        )
        if (!isACHCouponAlreadyAddedInRecurly) {
          const achData =
            thryvIds.length > 0 ? {locationThryvIds: thryvIds} : {}
          if (is5Order) {
            if (paymentMethod.value === 'ach') {
              const url = `cc/order/insertACHCoupon/${randomId}`
              const result = await client(url, {data: achData, method: 'POST'})
              console.log('result is :: ', result)
            } else {
              const url = `cc/order/deleteACHCoupon/${randomId}`
              const result = await client(url, {
                data: achData,
                method: 'DELETE',
              })
              console.log('result is :: ', result)
            }
          } else {
            if (paymentMethod.value === 'ach') {
              const url = `orders/insertACHCoupon/${randomId}`
              const result = await client(url, {data: achData, method: 'POST'})
              console.log('result is :: ', result)
            } else {
              const url = `orders/deleteACHCoupon/${randomId}`
              const result = await client(url, {
                data: achData,
                method: 'DELETE',
              })
              console.log('result is :: ', result)
            }
          }
        }
      }
      setPaymentState(prevState => ({...prevState, paymentMethod}))
    } catch (error) {
      console.log(error)
      // a failed switch used to escape as an unhandled rejection
      // (Fixes OOE-UI-1F)
      if (!error?.linkReplaced) {
        toast.error(
          error?.status
            ? error.message
            : 'Could not update the payment method. Please try again.',
        )
      }
    }
  }
  const getAddonTaxes = (addonsList, subscriptions) => {
    const addonsTaxes = addonsList.map(addon => {
      const {tax} = subscriptions.find(
        suscription => suscription.planCode === addon.addonPlanCode,
      ) || {tax: 0}
      return tax
    })
    return parsePrices(addonsTaxes)
  }

  const addPlanAsAddon = (plan, monthlyAddons, semiAnnuallyAddons) => {
    const planAsAddon = {addonPlanCode: plan.planCode}
    if (plan.planUnit === 'monthly') {
      monthlyAddons.push(planAsAddon)
    } else {
      semiAnnuallyAddons.push(planAsAddon)
    }
  }

  const getBillingSaveData = paymentResponse => {
    return {
      orderUuid: randomId,
      billingMethod:
        paymentState.paymentMethod.value === PAYMENT_METHODS[0].value
          ? 'CC'
          : 'ACH',
      recurlyToken: paymentResponse ? paymentResponse.id : undefined,
    }
  }

  const calculateTaxes = async arg => {
    try {
      setCalculatingTaxes(true)

      const paymentResponse = arg ?? recurlyToken
      const {flow} = paymentState.paymentInfo
      // order-capture-schema's order_flow enum is 'New'/'Update' (capitalized) —
      // 'upgrade' is the legacy screens/upgrade-order.js convention. Orders
      // created via the Account Setup Catalog Selection flow (including
      // "Create Purchase Link" on an existing location) use the former, so
      // both must be recognized here or a genuine upgrade order gets treated
      // as brand-new at payment time.
      const isUpgrade = flow === 'upgrade' || flow === 'Update'
      const data = getBillingSaveData(paymentResponse)
      const url = isUpgrade
        ? 'orders/process/upgrade/billing/save'
        : 'orders/process/billing/save'
      const result = await client(url, {data})
      const {total, tax, subscriptions, subtotal} = result
      const upgradeSubscriptions = isUpgrade
        ? [...result.updatedSubscriptions, ...result.newSubscriptions]
        : []
      const plan = paymentState.paymentInfo?.plan
      const monthlyAddons = []
      const semiAnnuallyAddons = []
      addPlanAsAddon(plan, monthlyAddons, semiAnnuallyAddons)
      monthlyAddons.push(...paymentState.monthlyAddons)
      semiAnnuallyAddons.push(...paymentState.semiAnnuallyAddons)

      setPaymentState(prevState => ({
        ...prevState,
        totalPaymentAmount: total,
        calculatedTaxes: tax,
        totalPaymentAmountWithoutTax: subtotal,
        subscriptions: isUpgrade ? upgradeSubscriptions : subscriptions,
        taxes: {
          monthly: getAddonTaxes(
            monthlyAddons,
            isUpgrade ? upgradeSubscriptions : subscriptions,
          ),
          semiAnnually: getAddonTaxes(
            semiAnnuallyAddons,
            isUpgrade ? upgradeSubscriptions : subscriptions,
          ),
          oneTime: getAddonTaxes(
            paymentState.oneTimeAddons,
            isUpgrade ? upgradeSubscriptions : subscriptions,
          ),
        },
      }))
      setCalculatingTaxes(false)
      setPaymentRequestState({
        hasErrors: false,
        requested: true,
        merchantMessage: null,
      })
    } catch (error) {
      setCurrentStep(2)
      setCheckBoxesValues({...checkBoxesValues, agreedTerms: false})
      setCalculatingTaxes(false)
      const merchantMessage = error?.data?.merchantMessage || null
      setPaymentRequestState({
        hasErrors: true,
        requested: true,
        merchantMessage,
      })
      if (error?.linkReplaced) {
        // shown as a banner by the payment gate
      } else if (error?.errors) {
        error.errors.forEach(({message}) => toast.error(message))
      } else if (error?.message) {
        toast.error(error.message)
      }
    }
  }
  const calculateTaxesCC = async arg => {
    try {
      setCalculatingTaxes(true)
      const paymentResponse = arg ?? recurlyToken
      const data = getBillingSaveData(paymentResponse)
      const url = 'cc/order/save-billing'
      const result = await client(url, {data})
      const {total, tax, newSubscriptions, updatedSubscriptions} = result
      const apps =
        updatedSubscriptions.find(
          ({planCode}) => planCode === 'appmarket-5-thryv-m2m',
        )?.addons || []
      const subscriptions = [...newSubscriptions, ...apps]
      const monthlyAddons = []
      monthlyAddons.push(...paymentState.monthlyAddons)

      setPaymentState(prevState => ({
        ...prevState,
        totalPaymentAmount: total,
        calculatedTaxes: tax,
        taxes: {
          monthly: getAddonTaxes(monthlyAddons, subscriptions),
          oneTime: getAddonTaxes(paymentState.oneTimeAddons, subscriptions),
        },
      }))
      setCalculatingTaxes(false)
      setPaymentRequestState({
        hasErrors: false,
        requested: true,
        merchantMessage: null,
      })
    } catch (error) {
      setCurrentStep(2)
      setCheckBoxesValues({...checkBoxesValues, agreedTerms: false})
      setCalculatingTaxes(false)
      const merchantMessage = error?.data?.merchantMessage || null
      setPaymentRequestState({
        hasErrors: true,
        requested: true,
        merchantMessage,
      })
      if (error?.linkReplaced) {
        // shown as a banner by the payment gate
      } else if (error?.errors) {
        error.errors.forEach(({message}) => toast.error(message))
      } else if (error?.message) {
        toast.error(error.message)
      }
    }
  }

  const parsePrices = prices => {
    let totalPrice = 0
    for (const i in prices) {
      totalPrice += prices[i]
    }
    return totalPrice
  }

  const getPaymentAmount = ({
    includePlanPrice = false,
    listOfAddons,
    isToday = false,
  }) => {
    let currency
    if (!is5Order) {
      const {plan} = paymentState.paymentInfo
      currency = plan.currency
      currency.amount = Number(currency.amount)
      currency.onboarding = Number(currency.onboarding)
    }
    const planPrice = includePlanPrice ? parsePrices([currency.amount]) : 0

    const addonsPrices = listOfAddons.map(addon => {
      // Upgrade: items already on the account (unchanged) are recurring only,
      // so they add nothing to what is due today.
      if (isToday && addon.isExisting) return 0
      // const rampInteval = addon?.rampIntervals[0]?.currencies?.find(
      //   ({currency}) => currency === addon?.currency?.currency,
      // )
      const rampInteval =
        addon?.rampIntervals && addon.rampIntervals.length > 0
          ? addon.rampIntervals[0]?.currencies?.find(
              ({currency}) => currency === addon?.currency?.currency,
            )
          : undefined
      const addonCurrency =
        rampInteval ||
        (!isToday && addon?.nextIntervalCurrency) ||
        addon?.currency
      if (addon.code !== 'addon-5-leadslift-m2m') {
        const price = (addon.quantity || 0) * (addonCurrency?.unitAmount || 0)
        if (
          isAus &&
          (addon.code === 'seobase-5-thryv-m2m' ||
            addon.code === 'addon-4-seobase-m2m' ||
            addon.code === 'addon-4-seopb-m2m' ||
            addon.code === 'addon-4-seokey-m2m' ||
            addon.code === 'addon-5-seopb-m2m' ||
            addon.code === 'addon-5-seokey-m2m')
        ) {
          return price * 1.1
        }
        return price
      }

      const entries = Object.entries(
        getAmountToQuantityMap(paymentState.paymentInfo?.country),
      )
      if (!entries.length) return addon?.currency?.unitAmount || 0 // fallback

      const closest = entries.reduce((prev, curr) =>
        Math.abs(curr[1] - addon.quantity) < Math.abs(prev[1] - addon.quantity)
          ? curr
          : prev,
      )

      return Number(closest[0])
    })

    return parsePrices([planPrice, ...addonsPrices])
  }

  const getListOfAddons = (
    {intervalUnit, intervalLength},
    flow,
    oldSubAddons,
  ) => {
    const {addons} = paymentState.paymentInfo

    const filteredAddons = (addons || []).filter(
      addon =>
        addon.intervalUnit === intervalUnit &&
        addon.intervalLength === intervalLength &&
        (addon?.currency?.unitAmount > 0 ||
          [
            'rc-4-thryv-m2m',
            'rc-5-thryv-m2m',
            'rc_basic-5-thryv-m2m',
            'rc_plus-5-thryv-m2m',
            'addon-4-stratcontent-m2m',
            'addon-4-listrefrsh-m2m',
          ].includes(addon.addonPlanCode)),
    )

    if (intervalUnit === 'days' && intervalLength === 1) {
      const addonsWithSetupFee = addons
        .filter(addon => {
          const isOldAddon = oldSubAddons?.some(({name}) => name === addon.name)
          if (flow === 'upgrade' && isOldAddon) return false
          return addon.currency.setupFee > 0
        })
        .map(addon => ({
          ...addon,
          planCode: `${addon.addonPlanCode}-setupfee`,
          name: `${addon.name} (Setup Fee)`,
          currency: {
            ...addon.currency,
            unitAmount: addon.currency.setupFee,
          },
        }))

      return [...addonsWithSetupFee, ...filteredAddons]
    }
    return filteredAddons
  }

  const formatPlanAndAddon = plan => {
    const formattedPlanAndAddOns = []

    formattedPlanAndAddOns.push(plan)
    for (const addon of plan.addons) {
      if (addon.isEntitlement) continue
      formattedPlanAndAddOns.push(
        formatMarketPlaceAddon(addon, plan.locationThryvId),
      )
    }
    return formattedPlanAndAddOns
  }

  // Nested addons (marketplace apps under `appmarket-5-thryv-m2m`, Keap apps
  // under the addon-5-keap-addons* wrapper, etc.) aren't tagged with their
  // own order_line.location_thryv_id by the backend — only the top-level
  // plan/wrapper is. Without inheriting `parentLocationThryvId` here, these
  // addons fall back to the order's own thryvId in groupItemsByLocation and
  // land in a spurious extra location group instead of their parent's.
  const formatMarketPlaceAddon = (addon, parentLocationThryvId) => {
    const {id, code, currencies, quantity, groupTitle} = addon
    let {name} = addon
    if (code.startsWith('max')) {
      if (name.startsWith('Thryv')) {
        name = name.replace('Thryv', '')
      }
    }
    const {curr} = paymentState.paymentInfo
    let currency
    if (currencies?.length > 0) {
      currency = currencies.find(({currency}) => currency === curr)
    } else {
      currency = {
        unitAmount: 0,
        currency: curr,
      }
    }
    return {
      ...addon,
      id,
      name,
      code,
      currency,
      groupTitle,
      locationThryvId: addon.locationThryvId ?? parentLocationThryvId,
      quantity:
        code === 'addon-5-seokey-m2m' ||
        code === 'addon-5-seopb-m2m' ||
        code.includes('addon-socialads') ||
        code.includes('addon-5-keap-hourlydatasvc') ||
        code.includes('addon-5-keap-addusers-m2m') ||
        code.includes('addon-5-ai-webbuilder')
          ? quantity
          : 1,
    }
  }

  const COMMAND_CENTER_NAME_MAPPING = {
    'cc_basic-5-thryv-m2m': 'My Account',
    'cc_basicpls-5-thryv-m2m': 'My Account',
    'cc_plus-5-thryv-m2m': 'My Account Plus',
    'cc_pro-5-thryv-m2m': 'My Account Pro',
  }

  const isKeapAddonsWrapper = code =>
    [
      'addon-5-keap-addons',
      'addon-5-keap-addons-annual',
      'addon-5-keap-addons-legacy-m2m',
      'addon-5-keap-addons-legacy-annual',
    ].includes(code)

  const getListOfCentersAndApps = ({intervalLength}) => {
    const {plans} = paymentState.paymentInfo
    const filteredPlans = plans
      .filter(plan =>
        !intervalLength && plan.code === 'appmarket-5-thryv-m2m'
          ? true
          : plan.intervalLength === intervalLength,
      )
      .flatMap(plan => {
        if (plan?.code === 'appmarket-5-thryv-m2m') {
          const EXCLUDED_APPMARKET_ADDONS = [
            'addon-5-signatures_usage',
            'app-websitebuilder',
          ]
          return plan.addons
            .filter(addon => !EXCLUDED_APPMARKET_ADDONS.includes(addon.code))
            .map(addon => formatMarketPlaceAddon(addon, plan.locationThryvId))
        } else if (isKeapAddonsWrapper(plan?.code)) {
          return plan.addons.map(addon =>
            formatMarketPlaceAddon(addon, plan.locationThryvId),
          )
        } else if (plan?.code === 'addon-5-keap-addons-annual') {
          return plan.addons.map(addon =>
            formatMarketPlaceAddon(addon, plan.locationThryvId),
          )
        } else if (
          plan?.code === 'mc_plus-5-thryv-m2m' ||
          plan?.code === 'mc_pro-5-thryv-m2m' ||
          plan?.code === 'seobase-5-thryv-m2m'
        ) {
          return formatPlanAndAddon(plan)
        } else if (plan?.code.startsWith('cc_')) {
          plan.name = COMMAND_CENTER_NAME_MAPPING[plan?.code]
          return plan
        } else if (plan?.code.startsWith('bc-6')) {
          if (plan.name === 'Thryv Business Center') {
            plan.name = 'Business Center'
            return plan
          }
          return plan
        } else if (plan?.code.startsWith('mc_')) {
          if (
            plan.name.startsWith('Thryv') &&
            !KEEP_THRYV_PREFIX_PRODUCT_CODES.includes(plan.code)
          ) {
            plan.name = plan.name.replace('Thryv', '')
            return plan
          }
          return plan
        } else if (plan?.code.startsWith('vert_')) {
          const addOns = plan?.addons
          if (plan.name.startsWith('Thryv')) {
            plan.name = plan.name.replace('Thryv', '')
            return plan
          }
          if (addOns && addOns !== undefined && addOns != null) {
            addOns.map(item => {
              if (item.name.startsWith('Thryv')) {
                return {
                  ...item,
                  name: item.name.replace('Thryv', ''),
                }
              }
              return item
            })
            return plan
          }
          return plan
        } else {
          return plan
        }
      })
      .filter(
        plan =>
          !(
            (intervalLength &&
              ONE_TIME_FEES.some(fee => {
                const planNameToLowerCase = plan.name.toLowerCase()
                if (planNameToLowerCase.includes('vertical')) {
                  // condition in order to avoid skipping multi month payment plan
                  return (
                    plan.name.toLowerCase().includes(fee) &&
                    plan.code.includes('-ot')
                  )
                } else {
                  return plan.name.toLowerCase().includes(fee)
                }
              })) ||
            (!intervalLength &&
              !ONE_TIME_FEES.some(fee => plan.name.toLowerCase().includes(fee)))
          ),
      )

    // GEP-6860: annual BNI plans are provisioned by Salesforce and must not
    // appear in Due Monthly. All three plans have interval_length:12 in Recurly,
    // so they land in the annual bucket — exclude from ALL interval buckets.
    const filteredPlansNoBniAnnual = filteredPlans.filter(
      plan =>
        !(
          SOCIAL_ADS_BNI_PLAN_CODES.includes(plan.code) &&
          plan.code.endsWith('-annual')
        ),
    )

    const filteredPlansWithImg = filteredPlansNoBniAnnual.map(plan => {
      return {
        ...plan,
        img: getPlanIcon(plan.name),
        ...(!plan.quantity && {quantity: 1}),
      }
    })
    return filteredPlansWithImg
  }

  const savePaymentContinue = () => {
    setFinalStep(true)
  }

  const handleMarketingCenterEnhanced = (payload, is5Order) => {
    // This is some ugly object mutation but it hides MC enhanced using a coupon from the rest of the page
    const mcEnhancedCouponIndex = payload.coupons.findIndex(c =>
      c.appliesToPlans?.includes('mc_pro_enh-5-thryv-m2m'),
    )
    const mcEnhancedCoupon = payload.coupons[mcEnhancedCouponIndex]
    const mcEnhancedPlan = is5Order
      ? payload.plans.find(p => p.code === 'mc_pro_enh-5-thryv-m2m')
      : payload.addons.find(p => p.code === 'addon-4-mcproenh-m2m')

    if (mcEnhancedCoupon && mcEnhancedPlan) {
      const couponAmount = mcEnhancedCoupon.discountAmount
      mcEnhancedPlan.currency.unitAmount -= couponAmount
      payload.coupons.splice(mcEnhancedCouponIndex, 1)
    }

    if (!payload.paymentPreview) return payload

    const mcEnhancedPreview = payload.paymentPreview?.centers?.find(
      ({planCode}) => planCode === 'mc_pro_enh-5-thryv-m2m',
    )

    if (mcEnhancedPreview) {
      mcEnhancedPreview.subtotal -= mcEnhancedPreview.discount
      payload.paymentPreview.discount -= mcEnhancedPreview.discount
      mcEnhancedPreview.discount = 0
    }

    return payload
  }

  React.useEffect(() => {
    const getPaymentInfo = async () => {
      if (randomId) {
        try {
          let url
          if (is5Order) {
            url = `cc/order/purchase-plan/${randomId}`
          } else {
            url = `orders/purchase-plan/${randomId}`
          }
          let result = await client(url)

          // If the order has plans tagged with more than one distinct
          // locationThryvId it is a multi-location (Parent Pay) order — re-fetch
          // with previewByLocation=true so the backend returns per-location
          // preview data instead of a single combined total.
          if (is5Order) {
            const distinctLocationIds = new Set(
              (result.plans || [])
                .map(plan => plan.locationThryvId)
                .filter(Boolean),
            )
            if (distinctLocationIds.size > 1) {
              result = await client(
                `cc/order/purchase-plan/${randomId}?previewByLocation=true`,
              )
            }
          }
          setRecurlyAccountId(result.recurlyAccountId)
          setCCOrderId(result.orderId)
          setThryvId(result.thryvId)
          // setClientEmail(result.clientEmail)
          setIsNewOrder(result.isNewOrder)
          setOrderData5CU(result.orderData5CU)
          setOrderData4CU(result.orderData4CU)
          setKeapAccount(result.keapAccount)
          console.log(thryvId)
          console.log(keapAccount)

          if (is5Order) {
            const isAlsphaSeoPresent = result.plans.some(({code}) =>
              ['seobase-5-thryv-m2m'].includes(code),
            )

            if (isAlsphaSeoPresent) {
              setIsSEOIncluded(result.isSEOIncluded)

              for (const plan of result.plans) {
                if (plan.code === 'seobase-5-thryv-m2m') {
                  plan.currency.unitAmount = 1
                }
              }
            }

            // seobase-5-thryv-bni-nt-m2m uses unitAmount=1/quantity=dollars in
            // Recurly, but cc/order/purchase-plan returns the real dollar price in
            // unitAmount. Force quantity=1 so planPrice = unitAmount × 1 (not ×quantity).
            for (const plan of result.plans) {
              if (plan.code === 'seobase-5-thryv-bni-nt-m2m') {
                plan.quantity = 1
              }
            }
          }
          // const isLLPresent = result.plans.some(({name}) =>
          //   ['Leads Lift'].includes(name),
          // )
          // if (isLLPresent) {
          //   for (let plan of result.plans) {
          //     if (plan.name === 'Leads Lift') {
          //       if (plan.currency.currency == 'AUD') {
          //         plan.currency.unitAmount = 1.1
          //       }
          //     }
          //   }
          // }
          const isTransitionCouponPresent = result.coupons.some(({code}) =>
            ['25month1', '25month2', '25month3'].includes(code),
          )

          handleMarketingCenterEnhanced(result, is5Order)

          if (
            is5Order &&
            (result.flow === 'upgrade' || result.flow === 'Update') &&
            !isTransitionCouponPresent
          ) {
            const transitionApplies = result.plans.some(
              ({transitionApplies}) => transitionApplies,
            )
            if (
              transitionApplies &&
              result.coupons.find(({code}) => code === 'transition75')
            ) {
              const transitionCoupons = [1, 2, 3].map(createTransitionCoupon)
              result.coupons.push(...transitionCoupons)
            }
          }
          const isAusNZCountry = ['AU', 'NZ'].includes(result?.country)
          setPaymentState(prevState => ({
            ...prevState,
            paymentInfo: {
              ...result,
              isInvoiceBilled: isAusNZCountry ? true : result.isInvoiceBilled,
            },
            ...(isAusNZCountry && {
              paymentMethod: {name: 'Invoice', value: 'invoice', icon: 'file'},
            }),
          }))
          if (isAusNZCountry) {
            setType('invoice')
          }
          setIsLoading(false)
        } catch (error) {
          if (error.status) {
            setHttpError(error)
          } else {
            setHttpError(NETWORK_ERROR)
          }
        }
      }
    }
    const getOrderDetails = async () => {
      console.log('ccorderId ---> ', ccorderId)
      if (randomId) {
        try {
          const url = is5Order
            ? `cc/order/core/fetchOrder?orderUuid=${randomId}`
            : `orders/core/fetchOrder?orderUuid=${randomId}`
          const result = await client(url)
          setOrderIdHeader(result?.order_header_id)
          setCCOrderId(result?.cc_order_id)
          setClientEmail(result?.email)
          setOrderCoreDetails(result)
        } catch (error) {
          if (error.status) {
            setHttpError(error)
          } else {
            setHttpError(NETWORK_ERROR)
          }
        }
      }
    }

    // both already surface failures via setHttpError; the .catch is a backstop
    // so nothing here can become an unhandled rejection (Fixes OOE-UI-1F)
    getPaymentInfo().catch(() => setHttpError(NETWORK_ERROR))
    getOrderDetails().catch(() => setHttpError(NETWORK_ERROR))
  }, [is5Order, randomId])

  React.useEffect(() => {
    let isMounted = true
    const getSubsByEmail = async () => {
      console.log('getSubsByEmail ---> ')
      if (!is5Order) {
        try {
          const url = `orders/validate-email/${clientEmail}`
          const SubsDetails = await client(url, {
            headers: {'app-type': 'client-payment-link'},
          })
          if (isMounted) {
            setSubscriptionIdAcc4(SubsDetails?.subscriptionId)
          }
        } catch (error) {
          if (!isMounted) return
          if (error.status) {
            setHttpError(error)
          } else {
            setHttpError(NETWORK_ERROR)
          }
        }
      }
    }
    if (clientEmail) {
      getSubsByEmail()
    }
    return () => {
      isMounted = false
    }
  }, [clientEmail])

  React.useEffect(() => {
    const getScheduleDetails = async () => {
      console.log('ccorderId ---> ', ccorderId)
      if (orderIdHeader) {
        try {
          let url
          url = `keappartner/fetchScheduleDetails/${orderIdHeader}`
          const result = await client(url)
          console.log('result', result)
          const details = result?.data?.apptDetails ?? []
          setOnboardingCalls(
            details?.filter(item => item.type === 'onboarding'),
          )

          setCreativeCalls(details?.filter(item => item.type === 'creative'))
          setThryvSuccessServicesCalls(
            details?.filter(item => item.type === 'thryv-success-services'),
          )
          setSoftwareUpgraded(result.softwareUpgraded)
        } catch (error) {
          if (error.status) {
            setHttpError(error)
          } else {
            setHttpError(NETWORK_ERROR)
          }
        }
      }
    }
    getScheduleDetails()
  }, [orderIdHeader])

  React.useEffect(() => {
    if (paymentState.paymentInfo && is5Order) {
      const centersAndAppsConfig = [
        {intervalLength: 1},
        {intervalLength: undefined},
        {intervalLength: 12},
      ]
      console.log({centersAndAppsConfig})
      const listOfCentersAndApps = centersAndAppsConfig.map(config =>
        getListOfCentersAndApps(config),
      )
      const paymentAmounts = centersAndAppsConfig.map((config, index) =>
        getPaymentAmount({listOfAddons: listOfCentersAndApps[index]}),
      )
      const [monthly, oneTime, annually] = paymentAmounts

      const monthlyTodayAmount = getPaymentAmount({
        listOfAddons: listOfCentersAndApps[0],
        isToday: true,
      })
      const oneTimeTodayAmount = getPaymentAmount({
        listOfAddons: listOfCentersAndApps[1],
        isToday: true,
      })
      const annualTodayAmount = getPaymentAmount({
        listOfAddons: listOfCentersAndApps[2],
        isToday: true,
      })

      const updatedPaymentState = {
        totalPaymentAmountNoTaxes: parsePrices(paymentAmounts),
        monthlyAmount: monthly,
        monthlyTodayAmount,
        oneTimeTodayAmount,
        annualTodayAmount,
        monthlyAddons: listOfCentersAndApps[0],
        oneTimeAmount: oneTime,
        oneTimeAddons: listOfCentersAndApps[1],
        annualAddons: listOfCentersAndApps[2],
        annualAmount: annually,
      }

      setPaymentState(prevState => ({
        ...prevState,
        ...updatedPaymentState,
      }))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [is5Order, paymentState.paymentInfo])

  React.useEffect(() => {
    if (paymentState.paymentInfo && !is5Order) {
      const {planUnit} = paymentState.paymentInfo.plan
      const {flow, oldSubAddons} = paymentState.paymentInfo
      const addonsConfig = [
        {intervalUnit: 'months', intervalLength: 1},
        {intervalUnit: 'months', intervalLength: 6},
        {intervalUnit: 'days', intervalLength: 1},
      ]
      const listOfAddons = addonsConfig.map(config =>
        getListOfAddons(config, flow, oldSubAddons),
      )

      const paymentAmounts = addonsConfig.map((config, index) => {
        const includePlanPrice =
          (planUnit === 'monthly' && index === 0) ||
          (planUnit === 'semi-annually' && index === 1)
        return getPaymentAmount({
          includePlanPrice,
          listOfAddons: listOfAddons[index],
        })
      })

      const isDomainValid = listOfAddons[2].some(
        addOn =>
          (addOn.addonPlanCode === 'ent-4-website-free' ||
            addOn.addonPlanCode === 'addon-4-website-m2m') &&
          addOn.isDomainValid,
      )

      const filteredOneTimeAddons = listOfAddons[2]

      if (isDomainValid) {
        paymentAmounts.pop()
      }

      const [monthly, semiAnnually, oneTime] = paymentAmounts

      const monthlyTodayAmount = parseFloat(
        getPaymentAmount({
          includePlanPrice: planUnit === 'monthly',
          listOfAddons: listOfAddons[0],
          isToday: true,
        }).toFixed(2),
      )

      const updatedPaymentState = {
        totalPaymentAmountNoTaxes: parsePrices(paymentAmounts),
        monthlyAmount: parseFloat(monthly.toFixed(2)),
        monthlyTodayAmount,
        monthlyAddons: listOfAddons[0],
        semiAnnuallyAmount: parseFloat(semiAnnually.toFixed(2)),
        semiAnnuallyAddons: listOfAddons[1],
        oneTimeAmount: oneTime,
        oneTimeAddons: filteredOneTimeAddons,
      }

      setPaymentState(prevState => {
        return {
          ...prevState,
          ...updatedPaymentState,
        }
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paymentState.paymentInfo, is5Order])

  React.useEffect(() => {
    setUuid(randomId)
  }, [randomId])
  React.useEffect(() => {
    const socket = io(REACT_APP_OOE_SERVICE_URL, {
      transports: ['websocket'],
    })
    const isTaxAvailable =
      paymentState.taxes.monthly ||
      paymentState.taxes.semiAnnually ||
      paymentState.taxes.oneTime
    socket.on('connect', () => {
      setConnected(true)
    })
    if (!connected) {
      return
    }

    function handleSocket({step, callbackFn = () => {}, errorMessage}) {
      const data = {uuid}
      if (step) {
        data.step = step
        nextStepCalled.current[`step${step}`] = true
      }
      if (errorMessage) {
        socket.emit('error-message', {message: errorMessage, uuid}, callbackFn)
      } else {
        socket.emit(step ? 'nextStep' : 'join', data, callbackFn)
      }
    }

    if (uuid && !nextStepCalled.current.step1) {
      handleSocket({callbackFn: () => handleSocket({step: 1})})
    }

    if (uuid && paymentRequestState.merchantMessage) {
      handleSocket({
        errorMessage: paymentRequestState.merchantMessage,
        callbackFn: () => {
          setPaymentRequestState({
            hasErrors: paymentRequestState.hasErrors,
            requested: paymentRequestState.requested,
            merchantMessage: null,
          })
        },
      })

      return () => {
        socket.close()
      }
    }

    if (
      !isMobileViewEnabled &&
      ((isAusNZ && paymentState.paymentInfo?.isInvoiceBilled) ||
        (frontendPreviewPayment && paymentState.paymentInfo?.paymentPreview))
    ) {
      if (isTaxAvailable !== null && !nextStepCalled.current.step2) {
        handleSocket({step: 2})
      } else if (isTaxAvailable !== null && !nextStepCalled.current.step3) {
        handleSocket({step: 3})
      }
    } else {
      if (isTaxAvailable !== null && !nextStepCalled.current.step2) {
        handleSocket({step: 2})
      }

      if (finalStep && !nextStepCalled.current.step3) {
        if (nextStepCalled.current[`step${2}`] === false) {
          handleSocket({step: 2})
        }
        handleSocket({step: 3})
      }
    }

    if (paymentState?.paymentInfo?.isInvoiceBilled && isAddressUpdated) {
      handleSocket({step: 2, callbackFn: () => handleSocket({step: 3})})
    }

    return () => {
      socket.close()
    }
  }, [
    connected,
    uuid,
    paymentState.taxes,
    finalStep,
    frontendPreviewPayment,
    paymentState.paymentInfo?.paymentPreview,
    isAusNZ,
    paymentState.paymentInfo?.isInvoiceBilled,
    isAddressUpdated,
    paymentRequestState?.merchantMessage,
  ])

  useEffect(() => {
    if (!uuid) return
    async function fetchLinkExpiryTimeCountDetails() {
      try {
        let response = {}
        const url = is5Order
          ? `cc/order/fetch-expiry/${uuid}`
          : `orders/fetch-expiry/${uuid}`
        response = await run(
          client(url, {
            headers: {'app-type': 'client-payment-link'},
          }),
        )

        if (response?.data) {
          const expiryInMilliSec =
            Number(response.data.configDetails[0].value) * 60000
          let linkGenerationTime
          if (response.data.updated_date) {
            linkGenerationTime = new Date(response.data.updated_date).getTime()
          } else {
            linkGenerationTime = new Date().getTime()
          }

          const linkGenerationTimeinMilliSec =
            linkGenerationTime + expiryInMilliSec
          const timeLeftInMilliSec =
            linkGenerationTimeinMilliSec - new Date().getTime()
          console.log({timeLeftInMilliSec})
          setLinkExpiryInMilliSec(Math.max(timeLeftInMilliSec, 0))
        }
      } catch (error) {
        console.error('Failed to fetch link expiry details:', error)
      }
    }
    fetchLinkExpiryTimeCountDetails()
  }, [uuid])
  React.useEffect(() => {
    async function deleteAchCouponUponRefresh() {
      console.log('Inside use Effect new function :: ', paymentState)
      // Check if ACH Coupon is added to the order, if yes delete from the order.
      // ACH coupon can not be present on the order, when the order is initially loaded
      const achCoupon = paymentState?.paymentInfo?.coupons?.filter(
        ele => ele.code === 'ach-discount',
      )
      if (achCoupon && achCoupon[0]) {
        if (is5Order) {
          const url = `cc/order/deleteACHCoupon/${randomId}`
          const data = {}
          const result = await run(
            client(url, {
              data,
              method: 'DELETE',
              headers: {'app-type': 'client-payment-link'},
            }),
          )
          console.log('result is :: ', result)
        } else {
          // Handle pre 5.0 order
          const url = `orders/deleteACHCoupon/${randomId}`
          const data = {}
          const result = await run(
            client(url, {
              data,
              method: 'DELETE',
              headers: {'app-type': 'client-payment-link'},
            }),
          )
          console.log('result is :: ', result)
        }
      }
    }
    // OOE-UI-FD: this refresh-time cleanup is best-effort, but its promise was
    // never consumed — so a 404 from an expired/unknown payment uuid ("No
    // order found for uuid ...") surfaced as an unhandled rejection on the
    // client payment page. Log and carry on; useAsync already records the
    // failure in its own error state.
    deleteAchCouponUponRefresh().catch(err => {
      console.error('deleteAchCouponUponRefresh failed:', err)
    })
    // eslint-disable-next-line
  }, [isLoading])

  React.useEffect(() => {
    if (!recurlyToken && !isCVCVerified) return undefined
    if (!agreedTerms) {
      clearRecurlyToken()
      return null
    }
    if (is5Order) {
      calculateTaxesCC(recurlyToken)
    } else {
      calculateTaxes(recurlyToken)
    }
  }, [is5Order, recurlyToken, isCVCVerified, agreedTerms])

  const updateParentAddress = async (
    addressInformation,
    bizphone,
    handleCompleteOrder,
  ) => {
    setCalculatingTaxes(true)
    try {
      const trim = v => (typeof v === 'string' ? v.trim() : v ?? '')
      const data = {
        orderUuid: uuid,
        firstName: trim(addressInformation.firstName),
        lastName: trim(addressInformation.lastName),
        company: trim(addressInformation.company),
        address: {
          address: trim(addressInformation.address),
          city: trim(addressInformation.city),
          state: trim(addressInformation.state),
          zipCode: trim(addressInformation.postalCode),
          country:
            addressInformation.country ||
            paymentState.paymentInfo?.country ||
            'US',
          phone: bizphone.toString(),
        },
      }
      await run(
        client('accounts/address', {
          data,
          method: 'PUT',
          headers: {'app-type': 'client-payment-link'},
        }),
      )
      setIsAddressUpdated(true)
      handleCompleteOrder()
    } catch (err) {
      toast.error(err.message)
    }
    setCalculatingTaxes(false)
  }

  if (httpError?.status === 404) {
    return <NotFoundPage />
  }
  if (httpError) {
    return <ErrorPage httpError={httpError} />
  }

  const displayLoading =
    calculatingTaxes || isFetchingRecurly || isVerifying || isFetching
  const loadingMessage = getLoadingMessage({
    isFetching,
    isFetchingRecurly,
    isVerifying,
    calculatingTaxes,
    isAus,
  })

  const handleSuccess = async () => {
    navigate('/success-acknowledge', {
      state: {
        email: clientEmail,
        flow: isNewOrder ? 'new order' : 'upgrade',
        onboardingCalls,
        creativeCalls,
        thryvSuccessServicesCalls,
        isCC: true,
        isSEOIncluded,
        softwareUpgraded,
        isAnnual:
          paymentState.annualAmount > 0 && paymentState.monthlyAmount === 0,
      },
    })
  }

  const handleProcessPurchase = async () => {
    if (is5Order) {
      processPurchaseCC()
    } else {
      processPurchase()
    }
  }

  const purchaseOrderDetailsPayload = () => {
    const accountInfo = paymentState?.paymentInfo?.accountInformation || {}
    const businessInfo = paymentState?.paymentInfo?.businessAddress || {}
    const plans =
      paymentState?.paymentInfo?.plans ||
      (paymentState?.paymentInfo?.plan ? [paymentState.paymentInfo.plan] : [])

    const linkId =
      orderCoreDetails?.link_id ||
      orderCoreDetails?.linkId ||
      paymentState?.paymentInfo?.link_id ||
      paymentState?.paymentInfo?.linkId ||
      orderData5CU?.order?.link_id ||
      orderData4CU?.order?.link_id

    const resolvedThryvId =
      thryvId ||
      orderData5CU?.order?.CCAccountInfo?.thryvId ||
      orderData4CU?.order?.CCAccountInfo?.thryvId ||
      paymentState?.paymentInfo?.thryvID ||
      paymentState?.paymentInfo?.thryvId ||
      orderCoreDetails?.thryv_id ||
      orderCoreDetails?.thryvId

    return {
      clientName: [
        businessInfo?.firstName || accountInfo.firstName,
        businessInfo?.lastName || accountInfo.lastName,
      ]
        .filter(Boolean)
        .join(' '),
      clientEmailId:
        clientEmail ||
        accountInfo.email ||
        businessInfo.email ||
        paymentState?.paymentInfo?.email,
      baseUrl: window.location.href,
      planName:
        plans
          ?.filter(
            item => !NON_ADDED_PLANS.includes(item.code || item.planCode),
          )
          ?.map(item => item.name)
          ?.filter(Boolean) || [],
      companyName:
        accountInfo.company ||
        businessInfo.company ||
        paymentState?.paymentInfo?.company,
      linkId,
      thryvId: resolvedThryvId,
    }
  }

  const resolvePurchaseOrderDetailsPayload = async () => {
    const orderDetails = purchaseOrderDetailsPayload()

    if (
      (!orderDetails.linkId && !orderIdHeader && !ccorderId) ||
      !orderDetails.thryvId
    ) {
      try {
        const url = is5Order
          ? `cc/order/core/fetchOrder?orderUuid=${randomId}`
          : `orders/core/fetchOrder?orderUuid=${randomId}`
        const coreDetails = await run(
          client(url, {
            headers: {'app-type': 'client-payment-link'},
          }),
        )

        if (coreDetails) {
          setOrderCoreDetails(coreDetails)
          if (coreDetails.order_header_id && !orderIdHeader) {
            setOrderIdHeader(coreDetails.order_header_id)
          }
          if (coreDetails.cc_order_id && !ccorderId) {
            setCCOrderId(coreDetails.cc_order_id)
          }

          orderDetails.linkId =
            orderDetails.linkId || coreDetails.link_id || coreDetails.linkId
          orderDetails.thryvId =
            orderDetails.thryvId || coreDetails.thryv_id || coreDetails.thryvId
        }
      } catch (error) {
        console.error(
          'Failed to fetch core order details for email payload',
          error,
        )
      }
    }

    if (
      shouldFetchPurchasePlanFallback(orderDetails, randomId) &&
      !orderIdHeader &&
      !ccorderId
    ) {
      try {
        const purchasePlan = await run(
          client(
            is5Order
              ? `cc/order/purchase-plan/${randomId}`
              : `orders/purchase-plan/${randomId}`,
            {headers: {'app-type': 'client-payment-link'}},
          ),
        )

        orderDetails.linkId =
          orderDetails.linkId || purchasePlan?.link_id || purchasePlan?.linkId
        orderDetails.thryvId =
          orderDetails.thryvId || purchasePlan?.thryvId || purchasePlan?.thryvID
      } catch (error) {
        console.error('Failed to fetch purchase plan for email payload', error)
      }
    }

    return orderDetails
  }

  const sendPurchaseOrderErrorDetails = async errorMessage => {
    const orderDetails = await resolvePurchaseOrderDetailsPayload()
    const resolvedCcOrderId = ccorderId || orderCoreDetails?.cc_order_id
    const missingFields = []

    if (!orderDetails.linkId && !orderIdHeader && !resolvedCcOrderId) {
      missingFields.push('linkId')
      missingFields.push('orderId')
      missingFields.push('ccOrderId')
    }

    if (!orderDetails.linkId && !orderIdHeader && !resolvedCcOrderId) {
      console.warn(
        `Skipping purchase error email: missing ${missingFields.join(', ')}`,
      )
      return
    }

    try {
      await run(
        client('keappartner/sendPurchseOrderErrorDetails', {
          data: {
            ...orderDetails,
            orderId: orderIdHeader,
            ccOrderId: resolvedCcOrderId,
            errorMessage,
          },
          method: 'POST',
          headers: {
            'app-type': 'client-payment-link',
          },
        }),
      )
    } catch (error) {
      console.error('Failed to send purchase error email', error)
    }
  }

  // const sendPurchaseOrderDetails = async () => {
  //   const orderDetails = await resolvePurchaseOrderDetailsPayload()
  //   const resolvedCcOrderId = ccorderId || orderCoreDetails?.cc_order_id
  //   const missingFields = []

  //   if (!orderDetails.linkId && !orderIdHeader && !resolvedCcOrderId) {
  //     missingFields.push('linkId')
  //     missingFields.push('orderId')
  //     missingFields.push('ccOrderId')
  //   }
  //   if (!orderDetails.thryvId) missingFields.push('thryvId')

  //   if (
  //     (!orderDetails.linkId && !orderIdHeader && !resolvedCcOrderId) ||
  //     !orderDetails.thryvId
  //   ) {
  //     console.warn(
  //       `Skipping partner order email: missing ${missingFields.join(', ')}`,
  //     )
  //     return
  //   }

  //   try {
  //     await run(
  //       client('keappartner/sendPurchseOrderDetails', {
  //         data: {
  //           ...orderDetails,
  //           orderId: orderIdHeader,
  //           ccOrderId: resolvedCcOrderId,
  //         },
  //         method: 'POST',
  //         headers: {
  //           'app-type': 'client-payment-link',
  //         },
  //       }),
  //     )
  //   } catch (error) {
  //     console.error('Failed to send purchase order details', error)
  //   }
  // }

  const processPurchase = async () => {
    // if (!orderCompleted) return
    try {
      setProcessingMessage('Processing Purchase...')
      setProcessing(true)
      const processResponse = await client(
        'orders/process/upgrade/purchase-asynchronous',
        {
          data: {
            orderId: orderIdHeader?.toString(),
            appUrl: window.location.origin,
          },
          headers: {
            'app-type': 'client-payment-link',
          },
        },
      )
      // FULSAS-14529: appointment errors are silenced at the backend — filter them as a safety net
      const _apptSteps4 = ['onboarding', 'thryv success services']
      const _displayErrors4 = processResponse.errors
        ? processResponse.errors.filter(({step}) => !_apptSteps4.includes(step))
        : []
      if (_displayErrors4.length > 0) {
        _displayErrors4.forEach(({message}) => toast.error(message))
        await sendPurchaseOrderErrorDetails(
          _displayErrors4.map(({message}) => message).join('\n'),
        )
        setProcessing(false)
      } else {
        //await captureCompleteOrder4()
        // await run(
        //   client('ordercapture/services/updateOrderStatus', {
        //     data: {order_id: orderIdHeader, order_status: 'Completed'},
        //     headers: {
        //       'app-type': 'client-payment-link',
        //     },
        //     method: 'PUT',
        //   }),
        // )
        //await sendPurchaseOrderDetails()
        setIsProcessPurchaseComplete(true)
        setProcessing(false)
        handleSuccess()
      }
      // nextStep()
    } catch (responseError) {
      setIsProcessPurchaseComplete(false)

      const errorMessage = responseError.message
        ? responseError.message
        : responseError.errors?.map(({message}) => message).join('\n')

      if (errorMessage) {
        //await sendPurchaseOrderErrorDetails(errorMessage)
      }

      setProcessing(false)
      if (responseError.linkReplaced) {
        // shown as a banner by the payment gate
        return
      }
      if (responseError.status === 404) {
        toast.error(responseError.message)
        throw responseError
      }
      if (responseError.status !== 400) {
        toast.error(responseError.message)
        throw responseError
      }
      if (responseError.message) {
        toast.error(responseError.message)
      } else {
        responseError.errors.forEach(({message}) => toast.error(message))
      }
    }
  }

  const processPurchaseCC = async () => {
    // if (!orderCompleted) return
    setProcessingMessage('Processing Purchase...')
    setProcessing(true)

    // A combined parentPay order has plans tagged with more than one distinct
    // locationThryvId (order_line.location_thryv_id) — process-purchase-asynchronous
    // only ever resolves ONE Recurly account (from order.thryv_id, the parent for a
    // combined order) and would subscribe every location's plans onto it. Route those
    // orders to process-multi-location-purchase instead, which splits by location.
    const distinctLocationThryvIds = new Set(
      (paymentState?.paymentInfo?.plans || [])
        .map(plan => plan.locationThryvId)
        .filter(Boolean),
    )
    const processEndpoint =
      distinctLocationThryvIds.size > 1
        ? 'cc/order/process-multi-location-purchase'
        : 'cc/order/process-purchase-asynchronous'

    try {
      const processResponse = await client(processEndpoint, {
        data: {
          orderId: orderIdHeader?.toString(),
          appUrl: window.location.origin,
        },
        headers: {
          'app-type': 'client-payment-link',
        },
      })

      let processErrorMsg = ''
      if (processResponse?.message) {
        processErrorMsg = processResponse.message
      } else if (
        processResponse?.errors &&
        Array.isArray(processResponse.errors)
      ) {
        // FULSAS-14529: appointment errors are silenced at the backend — filter them as a safety net
        const _apptStepsCC = ['onboarding', 'thryv success services']
        processErrorMsg = processResponse.errors
          .filter(({step}) => !_apptStepsCC.includes(step))
          .map(({message}) => message)
          .filter(Boolean)
          .join('\n')
      }

      if (processErrorMsg) {
        setProcessing(false)

        await sendPurchaseOrderErrorDetails(processErrorMsg)
        toast.error(processErrorMsg)
        return
      }

      // Success - complete the order
      //await captureCompleteOrder5()
      // if (is5Order) {
      //   await run(
      //     client('ordercapture/services/updateOrderStatus', {
      //       data: {order_id: orderIdHeader, order_status: 'Completed'},
      //       headers: {
      //         'app-type': 'client-payment-link',
      //       },
      //       method: 'PUT',
      //     }),
      //   )
      // }
      //await sendPurchaseOrderDetails()
      if (proposalInfo && proposalInfo?.proposalId) {
        await client(`proposals/${proposalInfo.proposalId}/updateStatus`, {
          data: {action: 'COMPLETED'},
        })
      }
      setProcessing(false)
      setIsProcessPurchaseComplete(true)
      handleSuccess()

      // setProcessing(false)
      // navigate('/success-acknowledge', {
      //   state: {
      //     email: clientEmail,
      //     flow: isNewOrder ? 'new order' : 'upgrade',
      //     onboardingCallDate,
      //     creativeCallDate,
      //     thryvSuccessServicesCallDate,
      //     isCC: true,
      //     isSEOIncluded: isSEOIncluded,
      //     softwareUpgraded: softwareUpgraded,
      //   },
      // })
    } catch (error) {
      setProcessing(false)
      setIsProcessPurchaseComplete(false)

      let errorMsg = ''

      console.error('processPurchaseCC error:', error)

      if (error.message === 'Failed to fetch') {
        errorMsg =
          "We couldn't confirm the response from your browser. This is usually caused by a momentary issue with your internet connection (like a VPN, proxy, or weak Wi-Fi).\n\nIf the new subscriptions are already showing in Recurly or in the account, the purchase probably went through. Please don't try the payment again until someone double-checks the order in OOE or Recurly.\n\nIf nothing has appeared yet, you can refresh the page and try again when you have a stable connection."
      } else if (error.message) {
        errorMsg = error.message
      } else if (error.errors && Array.isArray(error.errors)) {
        errorMsg = error.errors.map(({message}) => message).join('\n')
      } else if (error.toString) {
        errorMsg = error.toString()
      } else {
        errorMsg = 'An unexpected error occurred while processing the purchase'
      }

      if (errorMsg) {
        // setProcessPurchaseErrorMessage(errorMsg)
        // setShowProcessPurchaseErrorModal(true)
        //await sendPurchaseOrderErrorDetails(errorMsg)
        if (error.message !== 'Failed to fetch' && !error.linkReplaced) {
          toast.error(errorMsg)
        }
      }
    }
  }

  // const captureCompleteOrder5 = async () => {
  //   const fetchAccountSubscriptions = async (retriesAmount = 3) => {
  //     // Skip the call entirely when thryvId is missing — the server rejects
  //     // it with a 400 ("query.thryvId is not allowed to be empty") and the
  //     // failure was surfacing in Sentry as OOE-UI-83.
  //     if (!thryvId) return
  //     try {
  //       const url = `accounts/5/subscriptions?thryvId=${thryvId}`
  //       const response = await client(url, {
  //         headers: {
  //           'app-type': 'client-payment-link',
  //         },
  //       })
  //       if (
  //         !response.childSubscriptions.find(
  //           sub => sub.code === 'appmarket-5-thryv-m2m',
  //         ) ||
  //         !response.parentSubscriptions.find(sub => sub.code.includes('cc_'))
  //       ) {
  //         throw Error('missing subscription')
  //       } else {
  //         await getOrder5AndComplete(response)
  //       }
  //     } catch (err) {
  //       if (
  //         [404, 500].includes(err.status) ||
  //         err.message === 'missing subscription'
  //       ) {
  //         if (retriesAmount === 0) throw err
  //         // Awaited delay + return so the recursive retry's rejection
  //         // propagates through the outer .catch() rather than escaping
  //         // as an unhandled rejection via setTimeout.
  //         await new Promise(resolve => setTimeout(resolve, 1000))
  //         return fetchAccountSubscriptions(retriesAmount - 1)
  //       }
  //     }
  //   }
  //   // Fire-and-forget. Now that retries are awaited, every retry's
  //   // rejection (including exhausted-retries throws) lands here.
  //   fetchAccountSubscriptions().catch(err => {
  //     console.warn('fetchAccountSubscriptions exhausted retries', err)
  //   })
  //   // getOrder5AndComplete()
  // }

  // const captureCompleteOrder4 = async () => {
  //   const fetchAccountSubscriptions = async () => {
  //     try {
  //       const url = `subscription/uuid-${subscriptionIdAcc4}` /// ==============> check
  //       const response = await client(url, {
  //         headers: {
  //           'app-type': 'client-payment-link',
  //         },
  //       })
  //       if (response.thryvID) {
  //         await getOrder5AndComplete(response)
  //       }
  //     } catch (err) {
  //       // if (err.status === 404) {
  //       //   console.log(err)
  //       // }
  //       // if (err.status !== 404) {
  //       //   console.log(err)
  //       // }
  //       console.log(err)
  //       throw err
  //     }
  //   }
  //   fetchAccountSubscriptions()
  //   // getOrder5AndComplete()
  // }

  // const getOrder5AndComplete = async subscriptions => {
  //   try {
  //     console.log('getOrder5AndComplete - subscriptions', subscriptions)
  //     let subscriptionLines = []
  //     // if (isUpgrade || isNewOrder) {
  //     //   // =================> check
  //     // if (isNewOrder || isCCPlan) {
  //     // =================> check
  //     if (is5Order) {
  //       if (
  //         subscriptions &&
  //         subscriptions.parentSubscriptions &&
  //         subscriptions.childSubscriptions
  //       ) {
  //         subscriptionLines = [
  //           ...subscriptions.parentSubscriptions,
  //           ...subscriptions.childSubscriptions,
  //         ]
  //       }
  //     } else {
  //       if (subscriptions && subscriptions.addOns) {
  //         subscriptionLines = [...subscriptions.addOns]
  //       }
  //     }
  //     // }
  //     const url = `ordercapture/services/getOrderDetails/${orderIdHeader}` // =============> check
  //     const response = await client(url, {
  //       headers: {
  //         'app-type': 'client-payment-link',
  //       },
  //     })
  //     if (response.success) {
  //       console.log('get order header lines and discounts', response)
  //       console.log('get subscriptionLines', subscriptionLines)
  //       const order5Data = response.response
  //       if (order5Data) {
  //         order5Data.lines?.forEach(oLine => {
  //           subscriptionLines.forEach(subLine => {
  //             if (
  //               (subLine?.code && subLine?.code === oLine.saas_product_code) ||
  //               (subLine?.addOnCode &&
  //                 subLine?.addOnCode === oLine.saas_product_code)
  //             ) {
  //               oLine.recurly_subscription_id = subLine?.uuid
  //                 ? subLine?.uuid
  //                 : ''
  //               // oLine.saas_instance_id = subLine?.id ? subLine?.id : ''
  //             } else {
  //               if (subLine && subLine.addons && subLine.addons.length > 0) {
  //                 const addonLine = subLine.addons.find(
  //                   line =>
  //                     (line?.code && line?.code === oLine.saas_product_code) ||
  //                     (line?.addOnCode &&
  //                       line?.addOnCode === oLine.saas_product_code),
  //                 )
  //                 console.log('addonLine', addonLine)
  //                 if (addonLine) {
  //                   oLine.recurly_subscription_id = addonLine?.uuid
  //                     ? addonLine?.uuid
  //                     : addonLine?.subscriptionId
  //                     ? addonLine?.subscriptionId
  //                     : null
  //                   // oLine.saas_instance_id = addonLine?.id ? addonLine?.id : ''
  //                 }
  //               }
  //             }
  //           })
  //           oLine.order_line_status = 'Completed'
  //         })
  //         order5Data.order_status = 'Completed'
  //         order5Data.order_completed_date = new Date()
  //         order5Data.order_version =
  //           order5Data.order_version === 5 ? '5.0' : '4.0'
  //         await completeOrder5(order5Data)
  //       }
  //     }
  //     console.log('get order - ', response)
  //   } catch (error) {
  //     if (error.status !== 400) {
  //       console.log(`Error complete order: ${error.message}`)
  //     }
  //     if (error.errors) {
  //       // error.errors.forEach(({message}) => toast.error(message))
  //       error.errors.forEach(({message}) => console.log(message))
  //     } else {
  //       console.log(`Error complete order: ${error.message}`)
  //     }
  //     throw error
  //   }
  // }

  // const completeOrder5 = async order5Data => {
  //   try {
  //     console.log('order complete Data - new-upgrade', order5Data)
  //     order5Data.keap_account = keapAccount || false
  //     const result = await run(
  //       client('ordercapture/services/updateOrder', {
  //         data: order5Data,
  //         method: 'POST',
  //         headers: {
  //           'app-type': 'client-payment-link',
  //         },
  //       }),
  //     )
  //     console.log('order Completed - new-upgrade', result)
  //   } catch (error) {
  //     if (error.status !== 400) {
  //       console.log(
  //         `Error complete order - captureCompleteOrder5: ${error.message}`,
  //       )
  //     }
  //     if (error.errors) {
  //       // error.errors.forEach(({message}) => toast.error(message))
  //       error.errors.forEach(({message}) => console.log(message))
  //     } else {
  //       console.log(
  //         `Error complete order - captureCompleteOrder5: ${error.message}`,
  //       )
  //     }
  //     throw error
  //   }
  // }

  return (
    <>
      {isLoading && (
        <div
          style={{
            position: 'fixed',
            inset: 0,
            background: 'rgba(23, 29, 55, 0.7)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 9999,
          }}
        >
          <style>{`@keyframes pmtInitSpin { to { transform: rotate(360deg); } }`}</style>
          <span
            style={{
              display: 'inline-block',
              width: 28,
              height: 28,
              borderRadius: '50%',
              border: '3px solid rgba(255, 255, 255, 0.25)',
              borderTopColor: '#ffffff',
              animation: 'pmtInitSpin 0.7s linear infinite',
            }}
          />
        </div>
      )}
      {displayLoading && (
        <div style={{position: 'relative', zIndex: 999}}>
          <OverlayLoader
            is5Order={is5Order}
            className="d-flex justify-content-center align-items-center w-100 position-fixed"
          >
            {calculatingTaxes ? (
              <div
                style={{
                  backgroundColor: 'white',
                  borderRadius: '50px',
                  paddingTop: '48px',
                  paddingInline: '28px',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  minWidth: '240px',
                }}
              >
                <img
                  src={calculatingTaxesGif}
                  alt="Calculating taxes"
                  style={{
                    width: '141px',
                  }}
                />
                <ParagraphText
                  variant="sm"
                  className="font-weight-bold mt-4"
                  style={{
                    color: '#231F20',
                    whiteSpace: 'nowrap',
                    fontSize: '13px',
                  }}
                >
                  {loadingMessage}
                </ParagraphText>
                <img
                  src={thryvPeek}
                  alt="Thryver peeking"
                  style={{
                    width: '100%',
                    maxWidth: '141px',
                    transform: 'translateY(10px)',
                  }}
                />
              </div>
            ) : (
              <>
                <style>{`@keyframes overlaySpin { to { transform: rotate(360deg); } }`}</style>
                <span
                  style={{
                    display: 'inline-block',
                    width: '28px',
                    height: '28px',
                    borderRadius: '50%',
                    border: '3px solid rgba(255, 255, 255, 0.25)',
                    borderTopColor: '#ffffff',
                    animation: 'overlaySpin 0.7s linear infinite',
                  }}
                />
                <ParagraphText
                  variant="lg"
                  color="thryv-white-50"
                  className="font-weight-bold mt-4"
                >
                  {loadingMessage}
                </ParagraphText>
              </>
            )}
          </OverlayLoader>
        </div>
      )}
      {isMobileViewEnabled ? (
        <div className="mobile-payment-wrapper">
          <MobilePaymentHeader
            paymentState={paymentState}
            linkExpiryInMilliSec={linkExpiryInMilliSec}
            currentStep={currentStep}
            onBack={() => setCurrentStep(prev => Math.max(1, prev - 1))}
          />
          <div className="mobile-payment-card">
            <MobileLayout
              paymentState={paymentState}
              setPaymentRequestState={setPaymentRequestState}
              isLoading={isLoading || isFetching}
              calculateTaxes={is5Order ? calculateTaxesCC : calculateTaxes}
              calculatingTaxes={calculatingTaxes}
              setCalculatingTaxes={setCalculatingTaxes}
              handleChangePaymentMethod={handleChangePaymentMethod}
              linkExpiryInMilliSec={linkExpiryInMilliSec}
              paymentMethods={
                isNZ
                  ? NZ_PAYMENT_METHODS
                  : isAus
                  ? AUS_PAYMENT_METHODS
                  : isCA
                  ? CA_PAYMENT_METHODS
                  : PAYMENT_METHODS
              }
              savePaymentContinue={savePaymentContinue}
              uuid={uuid}
              paymentRequestState={paymentRequestState}
              is5Order={is5Order}
              setIsAddressUpdated={setIsAddressUpdated}
              bizphone={paymentState.paymentInfo?.businessAddress?.phone}
              isAddressUpdated={isAddressUpdated}
              updateParentAddress={updateParentAddress}
              currentStep={currentStep}
              setCurrentStep={setCurrentStep}
              handleProcessPurchase={handleProcessPurchase}
              isProcessPurchaseComplete={isProcessPurchaseComplete}
            />
          </div>
        </div>
      ) : (
        <DesktopLayout
          paymentState={paymentState}
          setPaymentState={setPaymentState}
          setPaymentRequestState={setPaymentRequestState}
          isLoading={isLoading || isFetching}
          calculateTaxes={is5Order ? calculateTaxesCC : calculateTaxes}
          calculatingTaxes={calculatingTaxes}
          setCalculatingTaxes={setCalculatingTaxes}
          linkExpiryInMilliSec={linkExpiryInMilliSec}
          handleChangePaymentMethod={handleChangePaymentMethod}
          paymentMethods={
            isNZ
              ? NZ_PAYMENT_METHODS
              : isAus
              ? AUS_PAYMENT_METHODS
              : PAYMENT_METHODS
          }
          savePaymentContinue={savePaymentContinue}
          uuid={uuid}
          paymentRequestState={paymentRequestState}
          isAddressUpdated={isAddressUpdated}
          setIsAddressUpdated={setIsAddressUpdated}
          updateParentAddress={updateParentAddress}
          handleProcessPurchase={handleProcessPurchase}
          isProcessPurchaseComplete={isProcessPurchaseComplete}
          handleSuccess={handleSuccess}
          // setOrderId={setOrderId}
          // orderId={orderId}
          // clientEmail={clientEmail}
          // isNewOrder={isNewOrder}
          // onboardingCallDate={onboardingCallDate}
          // creativeCallDate={creativeCallDate}
          // thryvSuccessServicesCallDate={thryvSuccessServicesCallDate}
          // isSEOIncluded={isSEOIncluded}
          // softwareUpgraded={softwareUpgraded}
          // orderData5CU={orderData5CU}
          // orderData4CU={orderData4CU}
          // keapAccount={keapAccount}
        />
      )}
      {processing && (
        <div
          style={{
            position: 'fixed',
            inset: 0,
            background: 'rgba(23, 29, 55, 0.7)',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 9999,
          }}
        >
          <style>{`@keyframes processSpin { to { transform: rotate(360deg); } }`}</style>
          <span
            style={{
              display: 'inline-block',
              width: '28px',
              height: '28px',
              borderRadius: '50%',
              border: '3px solid rgba(255, 255, 255, 0.25)',
              borderTopColor: '#ffffff',
              animation: 'processSpin 0.7s linear infinite',
            }}
          />
          <span
            style={{
              color: '#ffffff',
              fontWeight: 600,
              marginTop: '16px',
              fontSize: '16px',
            }}
          >
            {processingMessage}
          </span>
        </div>
      )}
    </>
  )
}

export {PaymentInformation}
